import React, { useCallback, useEffect, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link } from "react-router-dom";
import Spinner from "../../components/Spinner";
import useAuthFetch from "../../hooks/useAuthFetch";

const ROLE_LABELS = {
  dependiente: "Dependiente",
  bodega: "Bodega",
  mensajero: "Mensajero",
  administradorTienda: "Administrador de tienda",
  administradorInventario: "Administrador de inventario",
  integracionSistema: "Integración sistema",
  admin: "Administrador",
  superAdmin: "Super administrador",
};

function formatRoles(roles) {
  if (!roles) return "—";
  return roles
    .split(",")
    .map((role) => ROLE_LABELS[role.trim()] || role.trim())
    .join(", ");
}

const ColaboradoresPage = () => {
  const [colaboradores, setColaboradores] = useState(null);
  const [loading, setLoading] = useState(false);
  const authFetch = useAuthFetch();

  const fetchColaboradores = useCallback(async () => {
    setLoading(true);
    const res = await authFetch("usuarios/colaboradores");
    const data = await res.json();
    setColaboradores(Array.isArray(data) ? data : []);
    setLoading(false);
  }, [authFetch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchColaboradores();
  }, [fetchColaboradores]);

  return (
    <>
      {loading && <Spinner />}

      <div className="w-full p-content pb-16">
        <div className="flex w-full items-center">
          <div className="w-full flex justify-between">
            <div>
              <p className="text-2xl font-bold mb-4">
                Colaboradores
                {colaboradores ? ` (Total: ${colaboradores.length})` : ""}
              </p>

              <Link to="/colaboradores/new">
                <button
                  type="button"
                  className="bg-cyan text-white px-6 py-2 font-bold rounded-full flex justify-center items-center"
                >
                  {"+"} Nuevo colaborador
                </button>
              </Link>
            </div>

            <Link to="/cuenta">
              <button
                type="button"
                className="bg-pink text-white py-2 px-8 font-bold rounded-full float-right flex justify-center items-center"
              >
                <IoMdArrowRoundBack className="text-lg" /> Volver
              </button>
            </Link>
          </div>
        </div>
        <br />
        {colaboradores && colaboradores.length > 0 ? (
          colaboradores.map((colaborador) => (
            <div
              className="w-full ring-1 ring-purple rounded-lg mb-4 p-6"
              key={colaborador.id}
            >
              <p className="text-2xl">
                {[colaborador.nombre, colaborador.apellido1]
                  .filter(Boolean)
                  .join(" ") || colaborador.email}
              </p>
              <p className="text-md">
                Email:{" "}
                <span className="font-medium">{colaborador.email}</span>
              </p>
              {colaborador.telefono && (
                <p className="text-md">
                  Teléfono:{" "}
                  <span className="font-medium">
                    +{colaborador.codigoPaisTelefono} {colaborador.telefono}
                  </span>
                </p>
              )}
              <p className="text-md">
                Rol:{" "}
                <span className="font-medium">
                  {formatRoles(colaborador.roles)}
                </span>
              </p>
            </div>
          ))
        ) : (
          !loading && <p>No hay colaboradores para mostrar</p>
        )}
      </div>
    </>
  );
};

export default ColaboradoresPage;
